import React, { useState } from 'react';
import { 
  Dialog, 
  DialogContent, 
  DialogHeader, 
  DialogTitle, 
  DialogFooter
} from "../ui/dialog";
import { Button } from "../ui/button";
import { Trash2, X } from "lucide-react";
import { cn } from "../ui/utils";

interface RetireServiceDeskModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  deskName: string;
}

const RetireServiceDeskModal: React.FC<RetireServiceDeskModalProps> = ({ 
  isOpen, 
  onClose, 
  onConfirm,
  deskName 
}) => {
  const [confirmationText, setConfirmationText] = useState("");
  const isConfirmed = confirmationText === "RETIRE";

  const handleClose = () => {
    setConfirmationText("");
    onClose();
  };

  const handleConfirm = () => {
    if (isConfirmed) {
      onConfirm();
      setConfirmationText("");
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className="p-0 sm:max-w-md border-none overflow-hidden bg-white shadow-xl">
        <DialogHeader className="p-6 pr-12 border-b border-border flex-row items-center gap-3 space-y-0 text-left">
          <div className="p-2 bg-primary/10 rounded-lg shrink-0">
            <Trash2 className="w-5 h-5 text-primary" />
          </div>
          <DialogTitle className="text-xl font-bold leading-tight">Retire Service Desk</DialogTitle>
        </DialogHeader>

        <div className="p-6 pt-4 space-y-4">
          <p className="text-sm text-muted-foreground">
            Are you sure you want to retire the service desk "{deskName}"?
          </p>
          <p className="text-sm font-medium text-destructive">
            This change cannot be undone. If you proceed All existing tickets will be marked as CLOSED for auditing purposes.
          </p>
          
          <div className="space-y-2">
            <label className="block text-sm font-medium">
              Type <span className="font-bold text-destructive">RETIRE</span>
            </label>
            <input 
              type="text" 
              className="w-full px-4 py-2 bg-input-background border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-ring"
              placeholder="Type RETIRE"
              value={confirmationText}
              onChange={(e) => setConfirmationText(e.target.value)}
            />
          </div>
        </div>

        <DialogFooter className="p-6 border-t border-border bg-gray-50/50">
          <div className="grid grid-cols-2 gap-3 w-full sm:flex sm:justify-end">
            <Button 
              variant="outline" 
              onClick={handleClose}
              className="h-11 text-sm font-bold border-slate-200 text-slate-700 hover:bg-white transition-all bg-white"
            >
              Cancel
            </Button>
            <Button 
              onClick={handleConfirm}
              disabled={!isConfirmed}
              className="h-11 px-6 bg-red-600 hover:bg-red-700 text-white text-sm font-bold shadow-md transition-all disabled:opacity-50 disabled:cursor-not-allowed border-none"
            >
              Retire Desk
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RetireServiceDeskModal;
